export * as routes from './routes';
export * as languages from './languages';
export * as localStorage from './localStorage';

export const IS_PROD = process.env.NODE_ENV === 'production';
export const CLIENT_ID = process.env.GATSBY_CLIENT_ID;
export const BASE_API_ENDPOINT = process.env.GATSBY_API_URL;
export const STRIPE_TOKEN = process.env.GATSBY_STRIPE_PK;
